module["exports"] = [
  "град"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/city_suffix.js
// module id = 1291
// module chunks = 0